import React from 'react';

class FieldImage extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    static get defaultProps() {
        return {
            src: 'http://',
            alt: '',
            height: '',
            width: '',
            className: ''
        }
    }

    render() {
        let { src, alt, height, width, cssClass } = this.props;

        return (
            <span>
                <img src={ src } alt={ alt } height={ height } width={ width } className={ cssClass }/>
            </span>
        )
    }
}

export default FieldImage;


// WEBPACK FOOTER //
// ./src/js/components/configuratorElements/FieldImage.react.jsx